<template>
    <select
      v-bind="$attrs"
      class="base-select"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option
        v-for="opt in options"
        :key="opt[optionValue]"
        :value="opt[optionValue]"
      >
        {{ opt[optionLabel] }}
      </option>
    </select>
  </template>
  
  <script>
  export default {
    name: 'BaseSelect',
    props: {
      modelValue: [String, Number],
      options: {
        type: Array,
        default: () => []
      },
      optionValue: {
        type: String,
        default: 'value'
      },
      optionLabel: {
        type: String,
        default: 'label'
      }
    }
  }
  </script>
  
  <style scoped>
  .base-select {
    width: 100%;
    padding: 0.6rem 1rem;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 0.5rem;
    font-size: 1rem;
  }
  </style>
  